/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CompositeSearchEnhancedFilterConditionType } from './CompositeSearchEnhancedFilterConditionType';

export type CompositeSearchEnhancedFilterGrade = {
    filterType: CompositeSearchEnhancedFilterGrade.filterType;
    conditionType: CompositeSearchEnhancedFilterConditionType;
    value: Array<string>;
};

export namespace CompositeSearchEnhancedFilterGrade {

    export enum filterType {
        GRADE = 'grade',
    }


}

